import React from 'react'
import { useEditor } from 'tldraw'
import { Canvg } from 'canvg'

export function ExportButton() {
    const editor = useEditor()
    const params = new URLSearchParams(window.location.search)
    let imgUrl = params.get('detail')

    function getCookie(name) {
        return document.cookie
            .split("; ")
            .find((row) => row.startsWith(name + "="))
            ?.split("=")[1];
    }   

    const exportAsPng = async () => {
        if (!editor) return
    
        const shapes = editor.getCurrentPageShapes()
        if (shapes.length === 0) {
            alert('No hay contenido para exportar.')
            return
        }

        const shapeIds = shapes.map((shape) => shape.id)

        const svg = await editor.getSvg(shapeIds)  
        if (!svg) {
            alert('No se pudo generar el SVG.')
            return
        }
    
        const svgString = new XMLSerializer().serializeToString(svg);

        console.log(svgString);

/*      const width = parseInt(svg.getAttribute('width') || '1280')
        const height = parseInt(svg.getAttribute('height') || '768')

        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')

        const v = await Canvg.from(ctx, svgString)
        await v.render()

        const pngUrl = canvas.toDataURL('image/png')

        const link = document.createElement('a')
        link.href = pngUrl
        link.download = 'tldraw-export.png'
        link.click()

        setTimeout(() => {
            window.close();
        }, 10000); */

        
        try {
            const response = await fetch(imgUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getCookie('token')}`,
                },
                body:JSON.stringify({
                        data: { review_image: svgString }
                    }),
                })

                if (!response.ok) {
                    alert('Error al enviar el SVG.')
                    return
                }

                await response.json().then((res)=>{
                    console.log('Respuesta del servidor:', res);
                    alert('SVG enviado correctamente.');
                    window.close();
                })
            } catch (error) {
                console.error('Error en la solicitud:', error)
                alert('Error en la solicitud.')
            }
        }

return (
    <>
        <style>{`
            .export-btn {
                position: absolute;
                top: 8px;
                right: 180px;
                z-index: 1000;
                padding: 8px 12px;
                background: black;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
            }

            /* large tablets / small laptops */
            @media (max-width: 1024px) {
                .export-btn {
                    right: 100px;
                }
            }

            /* tablets / landscape phones */
            @media (max-width: 768px) {
                .export-btn {
                    right: 170px;
                    padding: 6px 10px;
                }
            }

            /* small phones */
            @media (max-width: 480px) {
                .export-btn {
                    right: 8px;
                    top: 8px;
                    padding: 6px 8px;
                    font-size: 14px;
                }
            }
        `}</style>

        <button className="export-btn" onClick={exportAsPng}>
            Exportar Imagen
        </button>
    </>
)
}
